import jp from 'jsonpath';

export function transformDataToFields(sourceData, mappedSource) {
  let fieldsArr = [];
  let id = 0;
  mappedSource.forEach((item, idx) => {
    try {
      let name = item.split('.')[item.split('.').length - 1].replace('[*]', '');
      let arrayData = jp.query(sourceData, item);
      id++;
      if (arrayData.length > 0) {
        if (typeof arrayData[0] === 'object') {
          fieldsArr.push({ key: id, path: item, name: name, values: arrayData.length > 0 ? arrayData : [], depth: item.split('.').length, isObj: true })
          // addField({ name: item, values: arrayData.length > 0 ? arrayData : [] });
          let keys = Object.keys(arrayData[0]);
          keys.forEach((keyItem, keyIdx) => {
            id++;
            let keyData = jp.query(sourceData, item + "." + keyItem);
            if (typeof keyData[0] !== "object") {
              let value = [];
              let i = 0;
              do {
                if (keyData[i]) {
                  value.push(`${keyData[i]}`);
                }
                i++;
              } while (i < 3);
              // addField({ name: keyItem, values: value });
              fieldsArr.push({ key: id, path: item + "." + keyItem, name: keyItem, values: value, depth: (item + "." + keyItem).split('.').length, isObj: false });
            }
          });
        } else if (typeof arrayData[0] === 'string') {
          let value = [];
          let i = 0;
          do {
            if (arrayData[i]) {
              value.push(arrayData[i])
            }
            i++;
          } while (i < 3);
          fieldsArr.push({ key: id, path: item, name: name, values: value, depth: item.split('.').length, isObj: false });
        };
      } else {
        fieldsArr.push({ key: id, path: item, name: name, values: [], depth: item.split('.').length, isObj: false });
      }
    } catch (error) {

    }
  });
  return fieldsArr;
}

export async function mapFeedSource(obj, parentKey = null, depth = 0, createdFeed) {
  let result = [];

  async function traverse(obj, parentKey, depth) {
    const currentKey = parentKey ? `${parentKey}` : '';

    if (Array.isArray(obj)) {
      result.push(`${currentKey}[*].`);
      await traverse(obj[0], `${currentKey}[*].`, depth + 1);
    } else if (typeof obj === 'object' && obj !== null) {
      Object.keys(obj).forEach(async subKey => {
        let path = `${currentKey}.${subKey}`;
        await traverse(obj[subKey], path, depth + 1);
      });
    } else if (typeof obj === 'string' || typeof obj === 'number') {
      result.push(`${parentKey}.`);
    }
  }

  await traverse(obj, parentKey, depth);

  if (result === null || result[0] === " " || result[0] === "") {
    result = ["$.*"];
  } else {
    result = result.map((item) => {
      let finalString = "";
      finalString = "$" + item;
      finalString = finalString.split('..').join('.');
      finalString = finalString.slice(0, (finalString.length - 1));
      return finalString;
    })
  }
  return [...new Set(["$", ...result])];
}
